export const ANGKATAN_PERTAMA = 1959;
export const SELF_ENTRY_INDEX_THRESHOLD = 25000;
export const EVENT_ID_SLA2026 = 6;
export const ColourCodes = [
    "rgba(130, 219, 216, 0.8)",
    "rgba(199,11,128,1)",
    "rgba(199,11,128,0.9)",
    "rgba(199,11,128,0.8)",
    "rgba(199,11,128,0.7)",
    "rgba(199,11,128,0.6)",
    "rgba(199,11,128,0.5)",
    "rgba(199,11,128,0.4)",
    "rgba(37,48,155,1)",
    "rgba(37,48,155,0.9)",
    "rgba(37,48,155,0.8)",
    "rgba(37,48,155,0.7)",
    "rgba(37,48,155,0.6)",
    "rgba(96,114,98,1)",
    "rgba(96,114,98,0.9)",
    "rgba(96,114,98,0.8)",
    "rgba(96,114,98,0.7)",
    "rgba(96,114,98,0.6)",
    "rgba(178,40,40,1)",
    "rgba(178,40,40,0.9)",
    "rgba(178,40,40,0.8)",
    "rgba(178,40,40,0.7)",
    "rgba(178,40,40,0.6)",
    "rgba(247,127,34,1)",
    "rgba(247,127,34,0.9)",
    "rgba(247,127,34,0.8)",
    "rgba(247,127,34,0.7)",
    "rgba(247,127,34,0.6)",
    "rgba(1,111,128,1)",
    "rgba(1,111,128,0.9)",
    "rgba(1,111,128,0.8)",
    "rgba(1,111,128,0.7)",
    "rgba(1,111,128,0.6)",
    "rgba(4,84,151,1)",
    "rgba(4,84,151,0.9)",
    "rgba(4,84,151,0.8)",
    "rgba(4,84,151,0.7)",
    "rgba(4,84,151,0.6)",
    "rgba(255,108,108,1)",
    "rgba(255,108,108,0.9)",
    "rgba(255,108,108,0.8)",
    "rgba(255,108,108,0.7)",
    "rgba(255,108,108,0.6)",
    "rgba(27,61,65,1)",
    "rgba(27,61,65,0.9)",
    "rgba(27,61,65,0.8)",
    "rgba(27,61,65,0.7)",
    "rgba(27,61,65,0.6)",
    "rgba(255,140,51,1)",
    "rgba(255,140,51,0.9)",
    "rgba(255,140,51,0.8)",
    "rgba(255,140,51,0.7)",
    "rgba(255,140,51,0.6)",
    "rgba(114,27,118,1)",
    "rgba(114,27,118,0.9)",
    "rgba(114,27,118,0.8)",
    "rgba(114,27,118,0.7)",
    "rgba(114,27,118,0.6)",
    "rgba(72,1,216,1)",
    "rgba(72,1,216,0.9)",
    "rgba(72,1,216,0.8)",
    "rgba(72,1,216,0.7)",
    "rgba(72,1,216,0.6)",
    "rgba(72,1,216,0.5)",
    "rgba(72,1,216,0.4)",
];
export const GrupColourCodes = [
    "rgba(199, 11,128,1)",
    "rgba( 37, 48,155,1)",
    "rgba( 96,114, 98,1)",
    "rgba(178, 40, 40,1)",
    "rgba(247,127, 34,1)",
    "rgba(  1,111,128,1)",
    "rgba(  4, 84,151,1)",
    "rgba(255,108,108,1)",
    "rgba( 27, 61, 65,1)",
    "rgba(255,140, 51,1)",
    "rgba(114, 27,118,1)",
    "rgba( 72,  1,216,1)",
];
export const GrupNames = [
    "Kanti Lamo",
    "Bugih Lamo",
    "Carano",
    "Tagalenjek",
    "Tarak Tacin",
    "Saayun Sabiduak",
    "Kacimuih",
    "KLA Project",
    "Bubua Champion",
    "Rang Mudo",
    "Salandbouw",
    "Anak Bawang",
];
export function grupIndex(g) {
    switch (true) {
        case g <= 1965: return 0;
        case g <= 1970: return 1;
        case g <= 1975: return 2;
        case g <= 1980: return 3;
        case g <= 1985: return 4;
        case g <= 1990: return 5;
        case g <= 1995: return 6;
        case g <= 2000: return 7;
        case g <= 2005: return 8;
        case g <= 2010: return 9;
        case g <= 2015: return 10;
        default: return 11;
    }
}
